// Plain-data catalog of every sidebar module/sub-module, for the
// per-institution Module Access settings screen. Hand-maintained
// mirror of the module/sub-module keys in components/Sidebar.js's
// `items` array (which is built inside that component using hooks/
// closures and isn't otherwise exportable) — keep the `value` fields
// here in sync with Sidebar.js's `value`/`children[].value` fields
// whenever the sidebar's structure changes. `admin-dashboard` is
// intentionally excluded (super-admin only, not per-institution).

export const moduleRegistry = [
  { value: "workflows", label: "Workflows" },
  {
    value: "sales",
    label: "Sales",
    children: [
      { value: "customer_entry", label: "Customers" },
      { value: "new_sales", label: "Sales" },
      { value: "sales_return", label: "Sales Return" },
    ],
  },
  { value: "pos", label: "POS" },
  {
    value: "quotation",
    label: "Quotation",
    children: [{ value: "quotation_entry", label: "Quotations" }],
  },
  {
    value: "order",
    label: "Order",
    children: [
      { value: "purchase_order_entry", label: "Purchase Order" },
      { value: "sales_order_entry", label: "Sales Order" },
    ],
  },
  {
    value: "service",
    label: "Service",
    children: [
      { value: "service_entry", label: "Service" },
      { value: "service_expense_entry", label: "Service Expense" },
    ],
  },
  {
    value: "purchase",
    label: "Purchase",
    children: [
      { value: "purchase_entry", label: "Purchase" },
      { value: "purchase_return", label: "Purchase Return" },
    ],
  },
  { value: "manufacturing", label: "Manufacturing" },
  {
    value: "inventory",
    label: "Inventory",
    children: [
      { value: "item_entry", label: "Products" },
      { value: "item_stock_report", label: "Item Stock Report" },
      { value: "item_adjustment_entry", label: "Item Adjustment" },
      { value: "item_ledger", label: "Item Ledger" },
      { value: "item_category", label: "Category" },
      { value: "generic_name", label: "Generic Names" },
      { value: "group_entry", label: "Group Entry" },
      { value: "item_unit", label: "Unit Entry" },
      { value: "model_manage", label: "Models" },
      { value: "origin_manage", label: "Origins" },
      { value: "rack_manage", label: "Racks" },
      { value: "transfer_entry", label: "Transfer Entry" },
      { value: "transfer_pending_record", label: "Transfer Pending Record" },
      { value: "transfer_receive_record", label: "Transfer Received Record" },
      { value: "transfer_record", label: "Transfer Record" },
      { value: "adjustment_record", label: "Adjustment Record" },
    ],
  },
  {
    value: "accounts",
    label: "Accounts",
    children: [
      { value: "account_entry", label: "Accounts" },
      { value: "income_entry", label: "Income" },
      { value: "expense_entry", label: "Expenses" },
      { value: "debtor_receipt", label: "Customer / Supplier Receipts" },
      { value: "creditor_payment", label: "Supplier / Customer Payment" },
      { value: "recurring_journal_entry", label: "Recurring Journals" },
      { value: "journal_entry", label: "Journal / Double" },
      { value: "contra_entry", label: "Contra / Single" },
      { value: "bank_transactions", label: "Bank Transactions" },
      { value: "cheque_entry", label: "Cheques" },
      { value: "advance_transaction_entry", label: "Advance Transactions" },
      { value: "branch_tran", label: "Branch Transactions" },
      { value: "expense_recognition_entry", label: "Expense Recognitions" },
    ],
  },
  {
    value: "hrpayroll",
    label: "HR & Payroll",
    children: [
      { value: "employee_entry", label: "Employees" },
      { value: "work_routes", label: "Work Routes" },
      { value: "attendance_entry", label: "Attendance" },
      { value: "salary_payment", label: "Salary Payments" },
      { value: "monthly_salary_report", label: "Monthly Salary Report" },
      { value: "salary_report", label: "Salary Payment Report" },
      { value: "onboarding", label: "Onboarding" },
      { value: "clients_entry", label: "Clients" },
      { value: "department_entry", label: "Departments" },
      { value: "designation_entry", label: "Designations" },
      { value: "hrlocation", label: "Branch Location" },
      { value: "hr_settings_view", label: "HR Settings" },
    ],
  },
  { value: "reports", label: "Reports" },
  {
    value: "crm",
    label: "CRM",
    children: [
      { value: "crm_leads", label: "Leads" },
      { value: "crm_deals", label: "Deals" },
      { value: "crm_tasks", label: "Tasks" },
      { value: "crm_customize", label: "Customization" },
      { value: "employee_wise_customer_list", label: "CRM Report" },
    ],
  },
  {
    value: "delivery",
    label: "Delivery",
    children: [
      { value: "delivery_jobs_manage", label: "Jobs & Execution" },
      { value: "delivery_routes_manage", label: "Routes & Tracking" },
    ],
  },
  { value: "settings", label: "Settings" },
];

export default moduleRegistry;
